import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "menu__container" }
const _hoisted_2 = { class: "p-2" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["textContent"]

import { toRefs, ref } from 'vue';
import Menu from 'primevue/menu';

interface PropsInterface {
  menuItems: {
    label: string;
    command?: () => void; // Explicitly define the function shape
    url?: string;
    icon?: { name: string; styles?: string };
  }[];
  icon?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionMenu',
  props: {
    menuItems: {},
    icon: {}
  },
  setup(__props: any) {

const props = __props;
const menu = ref<Menu>();
const { menuItems, icon = 'more_horiz' } = toRefs(props);

const toggleMenu = (toggle: Event) => {
  menu.value?.toggle(toggle);
  toggle.stopPropagation();
};

const executeCommand = (command: (() => void) | undefined, event: Event) => {
  event.stopPropagation();
  if (typeof command === 'function') {
    command();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "material-icons cursor-pointer hover:text-300",
      onClick: toggleMenu
    }, _toDisplayString(_unref(icon)), 1),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      class: "mt-2 ml-2 p-2",
      model: _unref(menuItems),
      popup: true
    }, {
      item: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_2, [
          (item.url)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: item.url
              }, [
                (item.icon)
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 0,
                      name: item.icon?.name,
                      class: _normalizeClass(item.icon.styles)
                    }, null, 8, ["name", "class"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "relative inline-block pl-2 pt-2 text-sm text-800",
                  textContent: _toDisplayString(item.label)
                }, null, 8, _hoisted_4)
              ], 8, _hoisted_3))
            : _createCommentVNode("", true),
          (item.command)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: (event) => executeCommand(item.command, event)
              }, [
                (item.icon)
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 0,
                      name: item.icon?.name,
                      class: _normalizeClass(item.icon.styles)
                    }, null, 8, ["name", "class"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "relative inline-block pl-2 pt-2 text-sm text-800",
                  textContent: _toDisplayString(item.label)
                }, null, 8, _hoisted_6)
              ], 8, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})